import Vue from "vue"
import Vuex from "vuex"
import * as url from "../common/utils/url"
import * as ua from "../common/utils/ua"
import Wechat from "../common/utils/wechat"
import * as types from "../bargain/store/mutation-types"
import cookies from "../common/utils/cookies"
import Raven from "raven-js"
import * as report from "../common/utils/report"
import * as userApi from "../common/api/user"
import localStorage from "../common/utils/localStorage"
import * as request from "../common/utils/request"
import * as config from "./config"
import * as api from "./api"
import * as userCommonAPI from "../common/api/user"
import * as uuid from "../common/utils/uuid"
import * as adsApi from "../common/api/ads"
import { UTC8TimeToTimeStamp } from "../bargain/utils/helper"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sandbox: url.getParam("sandbox"),
    pf: url.getParam("pf"),
    aid: url.getParam("aid"),
    offerId: url.getParam("offerId") || "1450019044",
    pkStarttime: "",
    totalParticipant: "",
    avatar: "",
    nickname: "",
    openid: "",
    openkey: "",
    sessionId: "",
    sessionType: "",
    accountType: "",
    wechatOpenid: "",
    wxAppid2: "",
    qqAppid: "",
    userAgent: ua.getUserAgent(),
    isInMSDK: ua.getUserAgent().msdk,
    selectedZone: "",
    selectedRole: "",
    supportRole: "",
    partitionInfo: "",
    gameInfo: config.GAME_INFO,
    isTeamCreatedShown: false,
    currentTeamId: "",
    captain: "",
    jackpot: "",
    individualJackpot: "",
    isLoading: false,
    loadingMsg: "",
    iosRechargeEnable: {}
  },
  getters: {
    offerId: state => state.offerId,
    sandbox: state => state.sandbox,
    pf: state => state.pf,
    isLoading: state => state.isLoading,
    loadingMsg: state => state.loadingMsg,
    loginState: state => {
      let session = {
        openid: state.openid,
        openkey: state.openkey,
        session_id: state.sessionId,
        session_type: state.sessionType,
        accountType: state.accountType
      }
      if (state.wxAppid2) {
        session.wx_appid = state.wxAppid2
      } else if (state.qqAppid) {
        session.qq_appid = state.qqAppid
      }
      return session
    },
    now: () => {
      let date = new Date(window._serverTime)
      if (date instanceof Date && !isNaN(date.valueOf())) {
        return date
      } else {
        return new Date()
      }
    }
  },
  actions: {
    jumpToMqq({ state }, jumpUrl) {
      if (!jumpUrl) {
        //默认跳活动首页
        jumpUrl = location.href
      }
      if (state.userAgent.weixin) {
        let wechat = new Wechat()
        wechat.api(
          "getInstallState",
          {
            packageUrl: "mqq://",
            packageName: "com.tencent.mobileqq"
          },
          res => {
            if (/get_install_state:yes/.test(res.err_msg)) {
              userApi.jumpToMqq(jumpUrl, state)
            } else {
              alert("请先下载手机QQ！")
            }
          }
        )
      } else {
        userApi.jumpToMqq(jumpUrl, state)
      }
    },
    getQQConnect({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (window.QC) {
          if (QC.Login.check()) {
            QC.Login.getMe((openid, accessToken) => {
              commit(types.SET_USER_LOGIN_STATE, {
                sessionId: "openid",
                sessionType: "kp_accesstoken",
                openid,
                qqAppid: "101502376",
                openkey: accessToken,
                accountType: "qq"
              })
              QC.api("get_user_info").success(function(res) {
                commit(types.SET_USER_AVATAR, res.data.figureurl_qq_2.replace(/https?/gi, "https"))
                commit(types.SET_USER_NICKNAME, res.data.nickname)
              })
              resolve()
            })
          } else {
            dispatch("qqConnectSignIn")
          }
        } else {
          reject("QC is undefined")
        }
      })
    },
    qqConnectSignIn() {
      //QQ互联不支持回调地址带hash，因此把hash参数和地址放到querystring中
      const s_url = `${location.protocol}//${location.host}${location.pathname}${url.delParam(["code", "state"], location.search)}${`${
        location.search ? "&" : "?"
      }hash=` + encodeURIComponent(location.hash.substr(1))}`

      const redirect_url = `https://graph.qq.com/oauth2.0/authorize?client_id=101502376&response_type=token&scope=all&redirect_uri=${encodeURIComponent(
        s_url
      )}&display=mobile
      `
      location.href = redirect_url
    },
    getLoginState({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (!state.openid || !state.openkey) {
          if (state.userAgent.weixin) {
            let wechat = new Wechat({
              getDetail: state.gameInfo.gameType == config.GAME_TYPE.PC_GAME ? 0 : 1
            })
            if (wechat.init()) {
              wechat.getOpenid({
                onSuccess: function() {
                  if (state.gameInfo.gameType == config.GAME_TYPE.PC_GAME) {
                    commit("SET_WECHAT_OPENID", this.openid)
                    dispatch("getQQConnect")
                      .then(resolve)
                      .catch(reject)
                  } else {
                    commit(types.SET_USER_LOGIN_STATE, {
                      openid: this.openid,
                      openkey: this.accessToken,
                      sessionId: "hy_gameid",
                      sessionType: "wc_actoken",
                      wxAppid2: "wx951bdcac522929b6",
                      accountType: "wechat"
                    })
                    if (this.info.headimgurl) {
                      commit(types.SET_USER_AVATAR, this.info.headimgurl.replace(/https?/gi, "https"))
                    }
                    if (this.info.nickname) {
                      commit(types.SET_USER_NICKNAME, this.info.nickname)
                    }
                    resolve({
                      openid: this.openid,
                      openkey: this.accessToken,
                      userInfo: this.info
                    })
                  }
                },
                onError: () => {
                  reject("getOpenidError")
                }
              })
            }
          } else if (state.userAgent.QQ || (cookies.get("uin") && cookies.get("skey"))) {
            let loginState = {
              openid: cookies.get("uin").substr(1) * 1,
              openkey: cookies.get("skey"),
              sessionId: "uin",
              sessionType: "skey",
              accountType: "qq"
            }
            commit(types.SET_USER_LOGIN_STATE, loginState)
            commit(types.SET_USER_AVATAR, `//q.qlogo.cn/g?b=qq&nk=${loginState.openid}&s=100`)
            dispatch("getQQNickname").then(res => {
              commit(types.SET_USER_NICKNAME, decodeURIComponent(res.nick))
            })
            resolve(loginState)
          } else if (window._msdkLoginParams && (state.isInMSDK || ua.getUserAgent().wzyd)) {
            if (_msdkLoginParams.acctype === "wx" || _msdkLoginParams.acctype === "weixin") {
              let loginState = {
                openid: _msdkLoginParams.openid,
                openkey: _msdkLoginParams.access_token,
                sessionId: "hy_gameid",
                sessionType: "wc_actoken",
                wxAppid2: _msdkLoginParams.appid,
                accountType: "wechat"
              }
              commit(types.SET_USER_LOGIN_STATE, loginState)
              dispatch("getWechatNicknameAndAvatar")
              resolve(loginState)
            } else if (_msdkLoginParams.acctype === "qq") {
              /**
               *  {
    "acctype": "qq",
    "appid": "1104922185",
    "openid": "4C5782CCFEF74AE493A71B526C43DDC1",
    "access_token": "E51744B676BDABA33EF0E9160609E279",
    "pay_token": "45DD6BF183D747520BCF974977835EFF",
    "platid": "0"
   }
               */
              let loginState = {
                openid: _msdkLoginParams.openid,
                openkey: _msdkLoginParams.access_token,
                sessionId: "openid",
                sessionType: "kp_accesstoken",
                qqAppid: _msdkLoginParams.appid,
                accountType: "qq"
              }
              commit(types.SET_USER_LOGIN_STATE, loginState)
              dispatch("getQQNickname").then(res => {
                if (res?.nick) commit(types.SET_USER_NICKNAME, decodeURIComponent(res.nick))
              })
              resolve(loginState)
            } else {
              reject("无登陆态")
            }
          } else if (url.getParam("openid") && url.getParam("openkey")) {
            let loginState = {
              openid: url.getParam("openid"),
              openkey: url.getParam("openkey"),
              sessionId: url.getParam("sessionid"),
              sessionType: url.getParam("sessiontype")
            }
            if (url.getParam("wxAppid2")) {
              loginState.wxAppid2 = url.getParam("wxAppid2")
              loginState.accountType = "wechat"
            }
            if (url.getParam("qq_appid")) {
              loginState.qqAppid = url.getParam("qq_appid")
              loginState.accountType = "qq"
            }

            commit(types.SET_USER_LOGIN_STATE, loginState)
            if (loginState.accountType == "wechat") {
              dispatch("getWechatNicknameAndAvatar")
            }

            if (loginState.accountType == "qq") {
              dispatch("getQQNickname").then(res => {
                if (res?.nick) commit(types.SET_USER_NICKNAME, decodeURIComponent(res.nick))
              })
            }
            resolve(loginState)
          } else {
            // dispatch("reportUserAction", {
            //   iformat: config.REPORT.PAGEVIEW.OUTGAME_BARGAIN_NON_WECHAT_AND_QQ
            // })
            // if (state.gameInfo.gameType == config.GAME_TYPE.PC_GAME) {
            //   dispatch("getQQConnect")
            //     .then(resolve)
            //     .catch(reject)
            // } else {
            reject("无登陆态")
            // }
          }
        } else {
          resolve({
            openid: state.openid,
            openkey: state.openkey,
            sessionId: state.sessionId,
            sessionType: state.sessionType,
            wxAppid2: state.wxAppid2
          })
        }
      })
        .then(loginState => {
          // document.querySelector("#page_loading").style.display = "none"
          return loginState
        })
        .catch(res => {
          // if (res == "无登陆态") {
          //   document.querySelector("#page_unlogin").style.display = "block"
          // }
          Raven.captureException(new Error("get-login-state-error"), {
            tags: { type: "get-login-state-error" },
            extra: {
              res,
              state
            }
          })
          // document.querySelector("#page_loading").style.display = "none"
          // document.querySelector("#app").style.display = "none"
          console.log(res)
          throw res
        })
    },
    getQQNickname({ state, getters }) {
      return userCommonAPI.wechatQuery(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          cmd: 1
        }
      )
    },
    getWechatNicknameAndAvatar({ state, commit }) {
      request
        .ajax({
          url: "//pay.qq.com/cgi-bin/account/get_wechat_userinfo.cgi",
          data: {
            get_detail: 2,
            openid: state.openid,
            access_token: encodeURIComponent(state.openkey)
          }
        })
        .then(res => {
          if (res.resultcode == 0) {
            commit(types.SET_USER_AVATAR, res.resultinfo.obj.headimgurl.replace(/https?/gi, "https"))
            commit(types.SET_USER_NICKNAME, res.resultinfo.obj.nickname)
          }
        })
    },
    reportUserAction({ state, getters }, params) {
      let source = "mds_client"
      if (state.userAgent.weixin) {
        source = "mds_wechat_qb"
      } else if (state.userAgent.QQ) {
        source = "mds_qq_qb"
      } else if (state.userAgent.msdk) {
        source = "mds_client"
      }
      let data = {
        3: state.openid,
        8: JSON.stringify(params.resultInfo || ""),
        // 19: getters.currentItem && getters.currentItem.code,
        13: 1,
        21: params.iformat,
        26: `${source}-${state.pf || "pay_html5"}_-html5`,
        24: getters.offerId,
        37: state.sessionId,
        43: state.sessionType,
        41: "wx951bdcac522929b6",
        50: navigator.userAgent,
        // 51: getters.aid,
        36: location.href
      }

      setTimeout(() => {
        report.dataReport(data)
      }, 0)
    },
    msdkShareTo({ dispatch, state }, { selected, team_id, pf }) {
      let shareParams = {
        // title: config.SHARE_DETAIL.OPEN_TITLE,
        desc: state.gameInfo.SHARE_INFO.DETAIL.DESC,
        title: state.gameInfo.SHARE_INFO.DETAIL.TITLE,
        url: `${state.gameInfo.SHARE_URL}${state.gameInfo.SHARE_URL.indexOf("?") > -1 ? "&" : "?"}pf=${pf}&offerId=${state.offerId}${
          state.sandbox ? "&sandbox=" + state.sandbox : ""
        }#/team/${team_id}?a=1`,
        // imgData: state.gameInfo.SHARE_INFO.DETAIL.INGAME_BASE64_ICON
        imgUrl: state.gameInfo.SHARE_INFO.DETAIL.ICON
      }

      if (selected === "weixin" || selected === "pengy") {
        shareParams.MsdkMethod = "WGSendToWeiXinWithUrl"
        shareParams.scene = selected === "weixin" ? "0" : "1"
        shareParams.mediaTagName = "MSG_INVITE"
        if (selected == "pengy") {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_TIMELINE_IN_GAME,
            resultInfo: `team_id=${team_id}`
          })
        }
        if (selected == "weixin") {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_WECHAT_IN_GAME,
            resultInfo: `team_id=${team_id}`
          })
        }
      } else {
        if (selected == "qzone") {
          shareParams.scene = 1
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_QZONE_IN_GAME,
            resultInfo: `team_id=${team_id}`
          })
        }
        if (selected == "qq") {
          shareParams.scene = 2
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_QQ_IN_GAME,
            resultInfo: `team_id=${team_id}`
          })
        }
        shareParams.MsdkMethod = "WGSendToQQ"
      }
      setTimeout(() => {
        if (window.msdkShare) {
          window.msdkShare(JSON.stringify(shareParams))
        }
      }, 100)
    },
    setOnShareHandler({ dispatch, state }, { page }) {
      let params = {
        wxAppid2: state.wxAppid2,
        img: state.gameInfo.SHARE_INFO.INDEX.ICON,
        url: `${state.gameInfo.SHARE_URL}${state.gameInfo.SHARE_URL.indexOf("?") > -1 ? "&" : "?"}${location.search.substr(1)}${
          location.hash
        }`
      }
      if (page == "index") {
        params.title = state.gameInfo.SHARE_INFO.INDEX.TITLE
        params.desc = state.gameInfo.SHARE_INFO.INDEX.DESC
      } else if (page == "detail") {
        params.title = state.gameInfo.SHARE_INFO.DETAIL.TITLE
        params.desc = state.gameInfo.SHARE_INFO.DETAIL.DESC
      }

      if (state.userAgent.QQ) {
        params.pf = "__mds_qq_share"
        params.reportCallback = res => {
          if (res.retCode == 0) {
            dispatch("reportUserAction", {
              iformat: config.REPORT.CLICK.SHARE_QQ_OUTSIDE_GAME_SUCESS
            })
          } else if (res.retCode == 1) {
            dispatch("reportUserAction", {
              iformat: config.REPORT.CLICK.SHARE_QQ_OUTSIDE_GAME_FAILURE
            })
          }
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_QQ_OUTSIDE_GAME
          })
        }

        userApi.setOnMqqShareHandler(params)
      } else if (state.userAgent.weixin) {
        params.pf = "__mds_wx_share"
        params.reportCallback = () => {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.SHARE_WECHAT_OUTSIDE_GAME
          })
        }
        userApi.setOnWechatShareHandler(params)
      }
    },
    getPCZoneInfo({ state }) {
      return request.getScript(state.gameInfo?.zoneJs?.url).then(() => {
        const results = []
        window[(state.gameInfo.zoneJs?.key)]?.STD_DATA?.forEach(item => {
          if (item?.opt_data_array?.length > 0) {
            item.opt_data_array.forEach(server => {
              results.push({ zone_id: server.v, zone_name: server.t })
            })
          } else {
            results.push({ zone_id: item.v, zone_name: item.t })
          }
        })
        return {
          zone_list: results
        }
      })
    },
    getPCGameRoleInfo({ state }, { zoneid }) {
      return userApi.getPCGameRoleInfo({
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        qqAppid: state.qqAppid,
        offerId: state.offerId,
        sandbox: state.sandbox,
        zoneid
      })
    },
    getMobileZoneInfo({ state, dispatch }) {
      if (state.gameInfo?.zoneJs?.url && state.gameInfo?.zoneJs?.key) {
        return dispatch("getPartitionZones")
      } else {
        return dispatch("getMidasZones")
      }
    },
    getMidasZones({ state }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        offerId: state.offerId,
        sandbox: state.sandbox,
        clientVersion: state.userAgent.iOS ? "iap" : "android"
      }
      return userApi.getMobileZones(params)
    },
    getPartitionZones({ state, getters }) {
      return request.getScript(state.gameInfo?.zoneJs?.url).then(() => {
        const results = window[(state.gameInfo.zoneJs?.key)]?.STD_DATA?.filter(item => {
          let sys, account
          if (getters.loginState.accountType == "wechat") {
            account = "weixin"
          } else if (getters.loginState.accountType == "qq") {
            account = "qq"
          }

          if (state.userAgent.iOS) {
            sys = "ios"
          } else if (state.userAgent.android) {
            sys = "android"
          }
          return item.sk == sys && item.ck == account
        }).map(item => ({ zone_id: item.v, zone_name: item.t, is_interworking: "0" }))
        return {
          zone_list: results
        }
      })
    },
    getMobileRoleInfo({ state }, { zoneid }) {
      let userAgent = ua.getUserAgent()
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        offerId: state.offerId,
        sandbox: state.sandbox,
        clientVersion: userAgent.iOS ? "iap" : "android",
        zoneid,
        useCmallQuery: state?.gameInfo?.shop?.busId == "2" ? true : false
      }
      return userApi.getMobileRoleInfo(params)
    },
    getRoleInfoByPartition({ state, getters }, { platformId, area, zoneid }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        offerId: getters.offerId,
        sandbox: state.sandbox,
        clientVersion: state.userAgent.iOS ? "iap" : "android",
        platformId,
        area,
        zoneid
      }
      return userApi.getRoleInfo(params)
    },
    setSelectedZone({ commit, state, getters }, zone) {
      commit(types.SET_SELECTED_ZONE, zone)
      localStorage.set(`team_pk_zone_${getters.offerId}_${state.openid}_${state.userAgent.weixin ? "wx" : "qq"}`, JSON.stringify(zone)) //把用户选过的大区存起来
    },
    setSelectedRole({ commit, state, getters }, role) {
      commit(types.SET_SELECTED_ROLE, role)
      localStorage.set(`team_pk_role_${getters.offerId}_${state.openid}_${state.userAgent.weixin ? "wx" : "qq"}`, JSON.stringify(role)) //把用户选过的角色存起来
    },
    setPartitionInfo({ commit }, partitionInfo) {
      commit("SET_PARTITION_INFO", partitionInfo)
    },
    setSupportRole({ commit }, supportRole) {
      commit("SET_SUPPORT_ROLE", supportRole)
    },
    getUserRecommendZone({ state, getters }) {
      let model = ""
      if (state.userAgent.iOS) {
        model = state.gameInfo.model.ios
      } else if (state.userAgent.android) {
        model = state.gameInfo.model.android
      }
      if (model) {
        return userApi.getUserRecommend({
          sandbox: state.sandbox,
          openid: state.openid,
          openkey: state.openkey,
          sessionId: state.sessionId,
          sessionType: state.sessionType,
          offerId: getters.offerId,
          wxAppid2: state.wxAppid2,
          model,
          ext: ""
        })
      } else {
        return ""
      }
    },
    createTeamProc({ state, getters }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          wechat_id: state.wechatOpenid || "",
          action: "create_team",
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    setTeamCreatedDialogShown({ commit }, shown) {
      commit("SET_TEAM_CREATED_DIALOG", shown)
    },
    setShareTeamId({ commit }, team_id) {
      commit("SET_TEAM_ID_FOR_SHARE", team_id)
    },
    setTeamCaptainInfo({ commit }, captain) {
      commit("SET_TEAM_CAPTAIN_INFO", captain)
    },
    getActivity({ state, commit }) {
      return Promise.resolve(state.gameInfo.activityInfo).then(res => {
        let ruleItem = res.filter(rule => rule.period == config.PEROID.PK)[0]
        if (ruleItem) {
          commit("SET_PK_START_TIME", UTC8TimeToTimeStamp(ruleItem.begin_time).getTime())
        }
        return res
      })
    },
    getTotalParticipant({ state, getters, commit }) {
      if (state.gameInfo.queryParticipant) {
        return userCommonAPI
          .followActivity(
            {
              offerId: state.offerId,
              sandbox: state.sandbox
            },
            {
              ...getters.loginState,
              drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`,
              accounttype: "qb",
              action: "drm_limit_query",
              buy_type: "buyteam",
              product_list: "JOIN",
              query_total: 1
            }
          )
          .then(res => {
            if (res.info.limit_info.resop_mpinfo.detail && res.info.limit_info.resop_mpinfo.detail.length > 0) {
              commit("SET_TOTAL_PARTICIPANT", res.info.limit_info.resop_mpinfo.detail[0].total_used_quota)
            }
          })
      }
    },
    /**
     * 查陌生人战队
     * @param state
     * @param getters
     */
    getStrangerTeam({ state, getters }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "query_strange_team",
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 获取战队信息
     * @param state
     * @param getters
     * @param team_id
     * @param filter_status
     * @returns {Promise<any>}
     */
    getTeamDetail({ state, getters }, { team_id = "", filter_status = "", pagesize = config.GAME_INFO.pagesize, curpage = 1 }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "query_team_detail",
          team_id,
          pagesize,
          curpage,
          filter_status,
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 解散战队
     * @param state
     * @param getters
     * @param team_id
     * @returns {Promise<any>}
     */
    dismissTeam({ state, getters }, { team_id }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "dismiss_team",
          team_id,
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 设置队伍审批开关
     * @param state
     * @param getters
     * @param team_id
     * @returns {Promise<any>}
     */
    setTeamApproval({ state, getters }, { team_id, need_approval }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "ctrl_team_approval",
          team_id,
          need_approval,
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 加入队伍
     * @param state
     * @param getters
     * @param team_id
     * @returns {Promise<any>}
     */
    joinTeam({ state, getters }, { team_id }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          wechat_id: state.wechatOpenid || "",
          action: "join_team",
          team_id,
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 审批成员入队
     * @param state
     * @param getters
     * @param team_id
     * @returns {Promise<any>}
     */
    approveMember({ state, getters }, { team_id, applicant, applicant_type, applicant_action }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "team_approval",
          team_id,
          applicant,
          applicant_type,
          applicant_action,
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 退出战队
     * @param state
     * @param getters
     * @param team_id
     * @returns {Promise<any>}
     */
    quitTeam({ state, getters }, { team_id }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "quit_team",
          team_id,
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 一键创建QQ群并在手Q内跳转到QQ群
     * @param state
     * @param getters
     * @returns {Promise<any>}
     */
    createQQGroup({ state, getters }) {
      return api
        .teamProc(
          {
            offerId: state.offerId,
            sandbox: state.sandbox
          },
          {
            ...getters.loginState,
            action: "create_qq_group",
            drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
          }
        )
        .then(res => {
          let groupid = res.info.group_code
          if (state.userAgent.QQ) {
            request.getScript(config.MQQ_URL).then(() => {
              mqq.ui.openAIO({
                uin: groupid,
                chat_type: "group"
              })
            })
          } else {
            location.href = "mqqapi://"
          }
        })
    },
    /**
     * 查询战队消费额
     * @param state
     * @param getters
     * @returns {Promise<any>}
     */
    getTeamConsumption({ state, getters }) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "query_team_amt",
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`
        }
      )
    },
    /**
     * 查询用户是否关注公众号
     * @param state
     * @param getters
     * @returns {Promise<any>}
     */
    queryFollow({ state }) {
      return Promise.resolve({ ret: 0, info: { is_followed: false }, state })
    },
    /**
     * 领取已解锁奖励
     * @param state
     * @param getters
     * @param present_rank
     * @returns {Promise<any>}
     */
    getTeamPresent({ state, getters }, present_rank) {
      return api.teamProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          action: "team_present",
          drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`,
          present_rank: present_rank / (state.gameInfo.shop.currencyRate || 1)
        }
      )
    },

    setJackPot({ commit }, jackpot) {
      commit("SET_JACKPOT", jackpot)
    },
    /**
     * 个人奖励
     * @param commit
     * @param jackpot
     */
    setIndividualJackpot({ commit }, jackpot) {
      commit("SET_INDIVIDUAL_JACKPOT", jackpot)
    },
    /**
     * 查奖品列表
     * @param state
     * @param getters
     * @returns {Promise | Promise<unknown>}
     */
    getDrawList({ state, getters }, { num }) {
      return userCommonAPI.luckDrawProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          zoneid: 1,
          accounttype: "qb",
          no_sig_check: 1,
          action: "query_productlist",
          card_id: state.gameInfo.luckDrawItem.filter(item => item.num == num)[0].card_id
        }
      )
    },
    /**
     * 获取王者荣耀道具配置信息,可以知道物品是皮肤或英雄
     * @param state
     * @returns {Promise<any | string>|Promise<T>}
     */
    getWzryPropsConfig({ state }) {
      if (state.gameInfo.gameType != config.GAME_TYPE.PC_GAME) {
        let cacheProps = localStorage.get(`${state.gameInfo.propsConfig.version}_wzry_props`, true)
        if (cacheProps) {
          return Promise.resolve(cacheProps)
        } else {
          return request
            .ajax({
              url: state.gameInfo.propsConfig.url
            })
            .then(res => {
              localStorage.set(`${state.gameInfo.propsConfig.version}_wzry_props`, JSON.stringify(res))
              return res
            })
        }
      }
    },
    getLuckCoupon({ state, getters }, { num }) {
      return userCommonAPI.luckDrawProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          zoneid: 1,
          accounttype: "qb",
          no_sig_check: 1,
          action: "query_coupon",
          card_id: state.gameInfo.luckDrawItem.filter(item => item.num == num)[0].card_id
        }
      )
    },
    getLuckDrawAward({ state, getters }, { curpage = 1, pagesize = 20, num }) {
      return userCommonAPI.luckDrawProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          curpage,
          pagesize,
          zoneid: 1,
          accounttype: "qb",
          no_sig_check: 1,
          card_id: state.gameInfo.luckDrawItem.filter(item => item.num == num)[0].card_id,
          action: "query_award"
        }
      )
    },
    luckyDraw({ state, getters }, { code_id, num }) {
      // return api.teamProc(
      //   {
      //     offerId: state.offerId,
      //     sandbox: state.sandbox
      //   },
      //   {
      //     ...getters.loginState,
      //     action: "lottery",
      //     game_platform_id: state.userAgent.iOS ? 0 : 1,
      //     gameid: `${state.partitionInfo.area}_${state.supportRole == 1 ? state.selectedRole.id : "_"}_${state.partitionInfo.partition}`,
      //     billno: `${new Date()
      //       .toISOString()
      //       .substr(0, 10)
      //       .replace(/-/g, "")}-${uuid.generate(7).toLowerCase()}`,
      //     luck_activity_id: state.gameInfo.luckDrawItem.filter(item => item.num == num)[0].card_id,
      //     drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`,
      //     code_id: code_id
      //   }
      // )
      return userCommonAPI.luckDrawProc(
        {
          offerId: state.offerId,
          sandbox: state.sandbox
        },
        {
          ...getters.loginState,
          no_sig_check: 1,
          zoneid: 1,
          action: "luck_lottery",
          game_platform_id: state.userAgent.iOS ? 0 : 1,
          /**
           * 获得用户的gameId
           * gameid区分端游和手游拼接模式
           * 端游为 "大区id_角色id"
           * 手游为 "area(标识手Q还是微信)_角色id__分区id"
           */
          gameid: `${state.partitionInfo.area}_${state.supportRole == 1 ? state.selectedRole.id : "_"}_${state.partitionInfo?.partition ||
            ""}`,
          billno: `${new Date()
            .toISOString()
            .substr(0, 10)
            .replace(/-/g, "")}-${uuid.generate(7).toLowerCase()}`,
          card_id: state.gameInfo.luckDrawItem.filter(item => item.num == num)[0].card_id,
          code_id: code_id
        }
      )
    },
    /**
     * 个人奖励
     * 不同档位的直增，cgi配置，将个人奖励的直增活动号和组队活动号关联
     * 前端调用team_proc(action:"self_amt_present")触发赠送
     * @param {*} param0
     * @param {*} rank
     * @returns
     */
    reveiveIndividualTaskPresent({ state, getters, dispatch }, rank) {
      const present_type = state.gameInfo.activityInfo
        .find(item => item.period == "pk")
        .individual_present_type.findIndex(item => item.num == rank)
      return api
        .teamProc(
          {
            offerId: state.offerId,
            sandbox: state.sandbox
          },

          {
            zoneid: 1,
            ...getters.loginState,
            action: "self_amt_present",
            game_platform_id: state.userAgent.iOS ? 0 : 1,
            /**
             * 获得用户的gameId
             * gameid区分端游和手游拼接模式
             * 端游为 "大区id_角色id"
             * 手游为 "area(标识手Q还是微信)_角色id__分区id"
             */
            gameid: `${state.partitionInfo.area}_${state.supportRole == 1 ? state.selectedRole.id : "_"}_${state.partitionInfo?.partition ||
              ""}`,
            // gameid: `${state.partitionInfo.area}_${state.supportRole == 1 ? state.selectedRole.id : "_"}_${state.partitionInfo.partition}`,
            drm_info: `group_id=${state.gameInfo.groupid}&version=3.0`,
            present_type: `rank_${present_type + 1}`
          }
        )
        .then(res => {
          dispatch("reportUserAction", {
            iformat: config.REPORT.PAGEVIEW.GET_INDIVIDUAL_PRIZE_SUC,
            resultInfo: {
              rank,
              res
            }
          })
          return res
        })
    },
    subscribeActivity({ state, getters, dispatch }, action) {
      return userApi
        .mobileSubscribe(
          {
            sandbox: getters.sandbox,
            offerId: getters.offerId
          },
          {
            ...getters.loginState,
            webversion: "MidasSubscribe1.0",
            groups: state.gameInfo.subscribeGroups,
            action
          }
        )
        .then(res => {
          dispatch("reportUserAction", {
            iformat: config.REPORT.PAGEVIEW.SUBSCRIBE_SUCCESS,
            resultInfo: res
          })
          return res
        })
        .catch(error => {
          // 旁路，不处理
          dispatch("reportUserAction", {
            iformat: config.REPORT.PAGEVIEW.SUBSCRIBE_ERROR,
            resultInfo: error
          })
        })
    },
    getOpenlink({ getters, dispatch }, url) {
      return userApi
        .getOpenlink(
          {
            offerId: getters.offerId,
            sandbox: getters.sandbox
          },
          {
            url,
            match_mode: 1
          }
        )
        .then(res => {
          dispatch("reportUserAction", {
            iformat: config.REPORT.PAGEVIEW.GET_OPENLINK_SUC,
            resultInfo: res
          })
          return res.info.openlink
        })
    },
    getConsumeAds({ state }) {
      if (state.gameInfo?.consumeAds?.url) {
        return adsApi.getAds(state.gameInfo.consumeAds.url, state.gameInfo.consumeAds.busId)
      } else {
        return ""
      }
    },
    setLoading({ commit }, bool) {
      commit("SET_LOADING", bool)
      commit("SET_LOADING_MSG", "")
    },
    setLoadingMsg({ commit }, msg) {
      commit("SET_LOADING", msg ? true : false)
      commit("SET_LOADING_MSG", msg)
    },
    checkIosWhiteListRecharge({ state, getters, commit }) {
      if (state.userAgent.iOS && state.iosRechargeEnable[`${state.offerId}_${getters.loginState.openid}`] === undefined) {
        return userCommonAPI
          .cmallQueryIosWhitelist({
            offerId: state.offerId,
            sandbox: state.sandbox,
            ...getters.loginState,
            clientVersion: state.userAgent.iOS ? "iap" : "android"
          })
          .then(res => {
            if (res.ret === 0) {
              commit(types.SET_IOS_RECHARGE_ENABLE, {
                offerId: `${state.offerId}_${getters.loginState.openid}`,
                iosRechargeEnable: res.in_whitelist
              })
            }
          })
      }
    }
  },
  mutations: {
    [types.SET_USER_LOGIN_STATE](state, { openid, openkey, sessionId, sessionType, wxAppid2, qqAppid, accountType }) {
      state.openid = openid
      state.openkey = openkey
      state.sessionId = sessionId
      state.sessionType = sessionType
      state.accountType = accountType
      wxAppid2 && (state.wxAppid2 = wxAppid2)
      qqAppid && (state.qqAppid = qqAppid)
    },
    [types.SET_USER_AVATAR](state, avatar) {
      state.avatar = avatar
    },
    [types.SET_USER_NICKNAME](state, nickname) {
      state.nickname = nickname
    },
    [types.SET_SELECTED_ZONE](state, zone) {
      state.selectedZone = zone
    },
    [types.SET_SELECTED_ROLE](state, role) {
      state.selectedRole = role
    },
    ["SET_PARTITION_INFO"](state, partitoinInfo) {
      state.partitionInfo = partitoinInfo
    },
    ["SET_SUPPORT_ROLE"](state, supportRole) {
      state.supportRole = supportRole
    },
    ["SET_TEAM_CREATED_DIALOG"](state, shown) {
      state.isTeamCreatedShown = shown
    },
    ["SET_TEAM_ID_FOR_SHARE"](state, team_id) {
      state.currentTeamId = team_id
    },
    ["SET_TEAM_CAPTAIN_INFO"](state, captain) {
      state.captain = captain
    },
    ["SET_JACKPOT"](state, jackpot) {
      state.jackpot = jackpot
    },
    ["SET_TOTAL_PARTICIPANT"](state, total) {
      state.totalParticipant = total
    },
    ["SET_PK_START_TIME"](state, time) {
      state.pkStarttime = time
    },
    ["SET_INDIVIDUAL_JACKPOT"](state, jackpot) {
      state.individualJackpot = jackpot
    },
    ["SET_WECHAT_OPENID"](state, openid) {
      state.wechatOpenid = openid
    },
    ["SET_LOADING"](state, bool) {
      state.isLoading = bool
    },
    ["SET_LOADING_MSG"](state, msg) {
      state.loadingMsg = msg
    },
    ["SET_IOS_RECHARGE_ENABLE"](state, { offerId, iosRechargeEnable }) {
      state.iosRechargeEnable[offerId] = iosRechargeEnable
      state.iosRechargeEnable = Object.assign({}, state.iosRechargeEnable)
    }
  },
  strict: process.env.NODE_ENV === "debug"
})
